import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Card from '../../components/cards/Card';
import Button from '../../components/buttons/Button';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import SearchBar from '../../components/searchBar/SearchBar';
import DatePicker from '../../components/inputFields/DatePicker';
import { toast } from 'react-toastify';
import { getShipments } from '../../services/shipment';
import { BiCopy, BiEdit, BiRefresh } from 'react-icons/bi';
import ShowModal from '../../utils/ShowModal';
import AddShipment from './AddShipment';

function Shipments() {
    const [cardData, setCardData] = useState([
        {
            title: "Total Shipments",
            count: "--",
        },
        {
            title: "New Shipments",
            count: "--",
        },
        {
            title: "Ready to Dispatch",
            count: "--",
        },
        {
            title: "In Transit",
            count: "--",
        },
        {
            title: "Returns",
            count: "--",
        },
    ]);


    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [shipmentDrawerItem, setShipmentDrawerItem] = useState(null);
    const [isShipmentDrawerOpen, setIsShipmentDrawerOpen] = useState(false);

    const openShipmentDrawer = (itemData) => {
        setShipmentDrawerItem(itemData);
        setIsShipmentDrawerOpen(true);
    };

    const closeShipmentDrawer = () => {
        setIsShipmentDrawerOpen(false);
        setShipmentDrawerItem(null);
        fetchData(`?shipped_date=${filterDate}`);
    };
    const headers = [
        { label: "ID", key: "id" },
        { label: "Action", key: "action" },
        { label: "Date", key: "created_at" },
        { label: "Partner", key: "partner" },
        { label: "Name", key: "name" },
        { label: "Order ID", key: "order" },
        { label: "Order Value", key: "order_value" },
        { label: "Dimentions (cm)", key: "dimentions" },
        { label: "Status", key: "status" },
        { label: "Delivery Date", key: "delivery_date" },
    ];

    const pageSize = 10;
    const [searchText, setSearchText] = useState("");
    const [filterDate, setFilterDate] = useState(new Date().toISOString().split('T')[0]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData(`?search=${query}&shipped_date=${filterDate}`);
    };

    const handleDateChange = (value) => {
        setFilterDate(value);
        fetchData(`?search=${searchText}&shipped_date=${value}`);
    };

    const resetFilters = () => {
        setSearchText("");
        setFilterDate("");
        fetchData("");
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getShipments(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`?shipped_date=${filterDate}`);
    }, []);

    const copyClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                toast.success('Copied to clipboard!');
            })
            .catch(() => {
                toast.error('Failed to copy');
            });
    };
    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Shipments' },
        ]} />
        <div className="py-3">
            <StyledHeadingText text={"Shipments"} />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.count} />
                ))}
            </div>
        </div>
        <div className="flex flex-row justify-between item-center">
            <div className="flex flex-row items-center gap-2">
                <SearchBar
                    placeholder="Search for Name | Order"
                    onSearch={handleSearch}
                    value={searchText}
                />

                {/* Date Picker */}
                <DatePicker
                    value={filterDate}
                    onChange={handleDateChange}
                    placeholder="Date"
                />
                {/* Reset Filters Icon */}
                {(searchText.length !== 0 || filterDate.length !== 0) && (
                    <BiRefresh
                        size={60}
                        className="cursor-pointer text-primary"
                        onClick={resetFilters}
                    />
                )}
            </div>
            <Button
                type="button"
                className="hover:bg-black hover:opacity-70 text-white bg-black rounded-md self-center"
                onClick={() => openShipmentDrawer({ fromPage: 'shipments' })}
            >
                Add Shipment
            </Button>
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                id: <span className='flex flex-row gap-1 items-center'><p className="max-w-16 truncate cursor-help" title={item.tracking_id}>{item.tracking_id}</p> <BiCopy
                                    className='cursor-pointer'
                                    color='blue'
                                    onClick={() => { copyClipboard(item.tracking_id) }}
                                /></span>,
                                action: <BiEdit size={20} className='text-blue-950 cursor-pointer' onClick={() => openShipmentDrawer({
                                    order_date: item.order_date,
                                    user: item.user_id,
                                    id: item.order,
                                    logistics: item,
                                    fromPage: 'shipments'
                                })} />,
                                created_at: <p>{item.shipped_date}</p>,
                                partner: <p>{item.provider}</p>,
                                name: <p>{item.farmer_name}</p>,
                                order: <span className='flex flex-row gap-1 items-center'><p className="max-w-16 truncate cursor-help" title={item.order}>{item.order}</p> <BiCopy
                                    className='cursor-pointer'
                                    color='blue'
                                    onClick={() => { copyClipboard(item.order) }}
                                /></span>,
                                order_value: <p>₹{item.cost}</p>,
                                dimentions: <p>{item.length || "-"} X {item.width || "-"} X {item.height || "-"} | {item.weight} KGs</p>,
                                status: <p>{item.order_status}</p>,
                                delivery_date: <p>{item.delivery_date || '—'}</p>,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}

                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
        <ShowModal
            contentLabel={"Shipment"}
            isOpen={isShipmentDrawerOpen}
            modalWidth="75%"
            isSidebar={true}
            onRequestClose={closeShipmentDrawer}
            componentToPass={
                <AddShipment
                    orderData={shipmentDrawerItem}
                    onClose={closeShipmentDrawer}
                    onSaved={() => fetchData(`?search=${searchText}&shipped_date=${filterDate}`)}
                    isDrawerMode={true}
                />
            }
        />
    </>);
}

export default Shipments;